import { ProductionViews } from "types";
import { startCase } from "lodash";
import { DEFAULT_ORG_VIEWS } from "lib/constants/defaults";

export const viewDisplayName = (
  viewId: string,
  orgProductionViews: ProductionViews,
  version?: string
) => {
  // If viewId is in orgProductionViews, use the title
  if (orgProductionViews[viewId]) {
    let displayName = orgProductionViews[viewId].title;

    // If version is provided, append it to the displayName
    if (version) {
      displayName = `${displayName} (${version.toUpperCase()})`;
    }

    return displayName;
  }

  // Fallback logic for views not configured in orgProductionViews
  let displayName;

  // Check if there's a default title in DEFAULT_ORG_VIEWS
  if (DEFAULT_ORG_VIEWS[viewId as keyof typeof DEFAULT_ORG_VIEWS]?.title) {
    displayName =
      DEFAULT_ORG_VIEWS[viewId as keyof typeof DEFAULT_ORG_VIEWS].title;
  } else {
    displayName = startCase(viewId);
  }

  // If version is provided, append it to the displayName
  if (version) {
    displayName = `${displayName} (${version.toUpperCase()})`;
  }

  return displayName;
};
